import { IconButton, styled } from '@mui/material';

export const StyledLogoContainer = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0, 2, 0, 0)
}));
